import { useFormContext } from 'form';
import { useTranslation } from 'i18n';
import { ConfirmationButton } from 'ui';

import { useDeleteMaterialProduct } from '../../hooks/useDeleteMaterialProduct/useDeleteMaterialProduct';
import { UpdateFormValues } from '../../pages/MaterialProductDetails/MaterialProductDetails';
import { MaterialProductFormValues } from '../../pages/schema';

export const DeleteMaterialProductButton = ({ id }: { id: number }) => {
  const { t } = useTranslation('orders');
  const form = useFormContext<MaterialProductFormValues, unknown, UpdateFormValues>();
  const { mutate: deleteMaterialProduct, isPending } = useDeleteMaterialProduct(form);

  return (
    <ConfirmationButton
      variant="secondary"
      title={t('materialProducts.deleteDialog.title')}
      onConfirm={() => deleteMaterialProduct({ id: id })}
      loading={isPending}
      fullWidth
    >
      {t('materialProducts.deleteDialog.actions.delete')}
    </ConfirmationButton>
  );
};
